<template>
  <bb-modal v-bind="modalProps" data-testid="open-savings-deposit-modal">
    <div class="header">{{ title }}</div>
    <div class="body">
      <bb-icon v-if="showIcon" class="icon" name="illustration-vault" size="fluid" fill="mint-70" />
      <div class="text">{{ text }}</div>
    </div>
    <div slot="footer" class="modal-footer">
      <div class="logout-wrapper">
        <bb-button v-bind="cancelButtonProps" @click="onCancel" data-testid="open-savings-deposit-skip-button" />
      </div>
      <div class="continue-wrapper">
        <bb-button v-bind="submitButtonProps" @click="onSubmit" data-testid="open-savings-deposit-continue-button" />
      </div>
    </div>
  </bb-modal>
</template>

<script>
import { mapState } from 'pinia'
import { useRootStore } from '@/store/root'
import '@bigbank/interface-components/dist/svg/illustration/vault'

export default {
  name: 'base-open-savings-deposit-modal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    onCancelLabel: {
      type: String,
      required: true
    },
    onSubmitLabel: {
      type: String,
      required: true
    },
    onCancelFn: {
      type: Function,
      required: true
    },
    onSubmitFn: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      areActionButtonsDisabled: false
    }
  },
  computed: {
    ...mapState(useRootStore, [
      'isMobile'
    ]),
    modalProps () {
      return {
        visible: this.isVisible,
        flavor: this.isMobile ? 'card' : 'user',
        fullMobile: true,
        centerVertically: !this.isMobile,
        hideClose: true,
        staticOverlay: true,
        publicSize: 'l'
      }
    },
    cancelButtonProps () {
      return {
        class: 'w-100',
        label: this.onCancelLabel,
        disabled: this.areActionButtonsDisabled,
        color: 'gray',
        inverted: true
      }
    },
    submitButtonProps () {
      return {
        class: 'w-100',
        label: this.onSubmitLabel,
        disabled: this.areActionButtonsDisabled
      }
    }
  },
  methods: {
    async onCancel () {
      this.areActionButtonsDisabled = true
      await this.onCancelFn()
    },
    async onSubmit () {
      this.areActionButtonsDisabled = true
      await this.onSubmitFn()
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  color: $blue;
  font-weight: 500;
  font-size: $font-size-small;
  font-family: $gotham-medium;
  line-height: 18px;
  text-align: center;
  margin-bottom: 30px;
}

.body {
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon {
    max-width: 250px;
  }

  .text {
    color: $gray;
    text-align: center;
    font-size: $font-size-small;
    font-family: $gotham-book;
    line-height: 18px;
    width: 333px;

    @media (max-width: $mobile-view-breaking-point) {
      width: auto;
      max-width: 275px;
    }

    margin-top: 35px;
  }
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  column-gap: 15px;
  padding: 10px;

  @media (max-width: $mobile-view-breaking-point) {
    padding: 10px;
    flex-direction: column;
    row-gap: 10px;
  }

  div {
    flex: 1 0 0;
  }
}
</style>
